import styled, {css} from "styled-components";

interface IStickyNavigationMenuItemBoxProps {
  type: string;
  isActive: boolean;
}

export const StickyNavigationMenuItemDefaultBox = styled.div<IStickyNavigationMenuItemBoxProps>`
  flex: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  font-size: 1rem;
  color: ${props => props.theme.colors.text};
  transition: color 0.2s ease;

  ${props => props.isActive && css`
    color: ${props => props.theme.colors.textLight};
  `}
  

  ${props => props.type === "deposit" && css`
    color: ${props => props.theme.colors.moneyColor};
  `}
`;
